import React from 'react';
import PropTypes from 'prop-types';

import SeparatorLine from '@components/SeparatorLine';
import { Check } from '@components/Icons';

import Container from '../components/Container';
import Content from '../components/Content';
import TextContainer from '../components/TextContainer';
import Label from '../components/Label';
import Text from '../components/Text';
import SeparatorContainer from '../components/SeparatorContainer';

function Select({ label, text, onSelect, selected, elementId, icon }) {
  return (
    <div id={elementId}>
      <Container onClick={onSelect}>
        <Content>
          {icon}
          <TextContainer>
            <div>
              <Label>{label}</Label>
              <Text>{text}</Text>
            </div>
          </TextContainer>
        </Content>
        <Check size="medium" color={selected ? 'default' : 'disabled'} />
      </Container>
      <SeparatorContainer>
        <SeparatorLine />
      </SeparatorContainer>
    </div>
  );
}

Select.propTypes = {
  text: PropTypes.string,
  label: PropTypes.string,
  selected: PropTypes.bool,
  onSelect: PropTypes.func.isRequired,
  elementId: PropTypes.string,
  icon: PropTypes.node,
};

Select.defaultProps = {
  selected: false,
};

export default Select;
